import { render, staticRenderFns } from "./OwnerManagerList.vue?vue&type=template&id=fa5d6b18&scoped=true&"
import script from "./OwnerManagerList.vue?vue&type=script&lang=js&"
export * from "./OwnerManagerList.vue?vue&type=script&lang=js&"
import style0 from "./OwnerManagerList.vue?vue&type=style&index=0&id=fa5d6b18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5d6b18",
  null
  
)

export default component.exports